import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["min", "max", "id", "disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isDisabled && !_ctx.sales_started)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["d-inline-flex ms-auto text-muted", _ctx.classInput])
        }, "Las ventas no han comenzado", 2))
      : _createCommentVNode("", true),
    (_ctx.isDisabled && _ctx.sales_ended)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["d-inline-flex ms-auto text-muted", _ctx.classInput])
        }, "Las ventas han finalizado", 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["input-group d-inline-flex", _ctx.classInput]),
      style: {"max-width":"150px"}
    }, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(["btn rounded", 
        _ctx.currentValue <= _ctx.defaults.min ? 'bg-gray text-dark' : 'btn-secondary'
      ]),
        type: "button",
        disabled: _ctx.isDisabled || _ctx.currentValue <= _ctx.defaults.min,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.substract && _ctx.substract(...args))),
        style: _normalizeStyle(
        _ctx.currentValue <= _ctx.defaults.min
          ? 'opacity: .2; cursor: not-allowed !important;'
          : ''
      )
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas", _ctx.currentValue == _ctx.defaults.min + 1 ? 'fa-trash' : 'fa-minus'])
        }, null, 2)
      ], 14, _hoisted_2),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control border-0 text-center bg-white",
        placeholder: "",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        style: {"-moz-appearance":"textfield"},
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentValue) = $event)),
        min: _ctx.defaults.min,
        max: _ctx.defaults.max,
        "aria-label": "Example text with button addon",
        id: _ctx.id,
        disabled: _ctx.isDisabled
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.currentValue]
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn rounded", 
        _ctx.currentValue >= _ctx.defaults.max ? 'bg-gray text-dark' : 'btn-secondary'
      ]),
        type: "button",
        disabled: _ctx.currentValue >= _ctx.defaults.max || _ctx.isDisabled,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
        style: _normalizeStyle(
        _ctx.currentValue >= _ctx.defaults.max
          ? 'opacity: .2; cursor: not-allowed !important;'
          : ''
      )
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
      ]))], 14, _hoisted_4)
    ], 2)
  ], 64))
}